import React, { useMemo } from 'react';
import { useUser } from '../../../state/user';
import { useLayoutDispatchers } from '../../../state/layout';
import AppDownloadLinks from '../AppDownloadLinks';

import css from './PlanFlowComplete.module.scss';

const planCopyMap = {
  max: {
    planName: 'Greenlight Max',
    planCost: '9.98'
  },
  infinity: {
    planName: 'Greenlight Infinity',
    planCost: '14.98'
  }
};

const PlanFlowComplete = () => {
  const { setLayout } = useLayoutDispatchers();
  useMemo(() => setLayout('compressed'), []);
  const {
    partner,
    promotionId,
    registeredUser,
    currentPlan: planName
  } = useUser();
  const childCount = registeredUser?.user?.children?.length;
  const currentPlan = planName || 'standard';

  return (
    <>
      <img
        className={css.completeImage}
        data-e2e="complete-image"
        src={`../../../static/plan-flow-complete.png`}
        alt="Greenlight app user"
      />
      <div className={css.contentContainer}>
        <h3 className={css.heading} data-e2e="plan-flow-complete-heading">
          Nice! You&apos;re all signed up
        </h3>
        <p className={css.body} data-e2e="plan-flow-complete-body">
          Your {planCopyMap[currentPlan].planName} trial starts now. Use your
          app for investing and more. After your first month, your plan is $
          {planCopyMap[currentPlan].planCost}/mo.
        </p>
        <div className={css.planSection}>
          <img
            src="../../../static/gl-max-card.svg"
            alt="Greenlight card"
            data-e2e="plan-flow-complete-card-image"
          />
          <div className={css.planDetails}>
            <div
              className={css.planName}
              data-e2e="plan-flow-complete-plan-name"
            >
              Plan: {planCopyMap[currentPlan].planName}
            </div>
            {childCount && (
              <div data-e2e="plan-flow-complete-card-count">
                {childCount} {childCount === 1 ? 'card' : 'cards'}
              </div>
            )}
            <div
              className={css.arrivalEstimate}
              data-e2e="plan-flow-complete-arrival-estimate"
            >
              Arrives in 7–10 business days
            </div>
          </div>
        </div>
        <div className={css.appLinksContainer}>
          <h4
            className={css.appLinksHeading}
            data-e2e="plan-flow-complete-app-links-heading"
          >
            Get started by installing the app
          </h4>
          <div className={css.appLinksWrapper}>
            <AppDownloadLinks promoId={promotionId} partner={partner} />
          </div>
        </div>
      </div>
    </>
  );
};

export default PlanFlowComplete;
